import React, { useState, useRef } from 'react';
import Portal from '../Portal/Portal';
import { useOnClickOutside } from './useOnClickOutside';
import styles from './styles.module.css';

const ViewWithPopup = ({ view, popup, noView = false, style, className }) => {
  const [showPopup, setShowPopup] = useState(false);
  const ref = useRef();

  useOnClickOutside(ref, () => setShowPopup(false));

  return (
    <div className={styles.wrapper} ref={ref}>
      {view && noView && <div onClick={() => setShowPopup(!showPopup)}>{view}</div>}
      <div onClick={() => setShowPopup(true)} className={styles.popupWrapper}>
        {view && !noView && view}
        {showPopup && (
          <div id="popup" className={styles.popup}>
            <Portal rendererId="popup">{popup && popup}</Portal>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewWithPopup;
